import axiosInstance from './AxiosInstance';

const API_URL = '/chatbot';

// history: array of { role: 'user' | 'assistant', content: string } — the
// caller (ChatbotPage) keeps this and resends it each turn, same pattern as
// any other stateless REST call in this app; the backend has no server-side
// session for it.
export const sendChatbotMessage = async (message, history = []) => {
  const response = await axiosInstance.post(`${API_URL}/message`, { message, history });
  return response.data.data; // { reply, toolsUsed }
};
